import { fetchClientApiStep } from '../clientApiStep.helpers';

/**
 * POSTs the chosen slot's resolved dependency body to the outreach
 * AppointmentPicking book step through the gateway proxy, returning the
 * booking reference id and the whole response. The errors-array check lives
 * in the shared fetch, ahead of the shape check below, so it applies here too.
 */
// eslint-disable-next-line import/prefer-default-export
export const bookClientApiAppointment = async ({
  api,
  body,
  submissionId,
  token,
}) => {
  try {
    const response = await fetchClientApiStep({
      api,
      body,
      submissionId,
      token,
      label: 'Booking',
    });

    const referenceId = response.data?.referenceId;
    if (typeof referenceId !== 'string' || referenceId === '') {
      throw new Error('Booking returned an unexpected response shape');
    }

    return { referenceId, request: body, response };
  } catch (error) {
    if (error && typeof error === 'object') {
      error.request = body;
    }
    throw error;
  }
};
